import React from 'react';
import { Article } from '../../models/Article';
import ArticleApproval from './ArticleApproval';

interface ArticleApprovalRouteWrapperProps {
  article: Article;
}

export default function ArticleApprovalRouteWrapper({ article }: ArticleApprovalRouteWrapperProps) {
  return <ArticleApproval article={article} />;
}
